import { z } from 'zod';

import type { TranslateFn } from '@/shared/types';

export function stringMinMax(t: TranslateFn, min: number, max: number): z.ZodString {
    return z
        .string()
        .min(min, t('validation.string.min', { count: min }))
        .max(max, t('validation.string.max', { count: max }));
}
